function SelectInputDropdownArrow() {
  return (
    <div>
      <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.00035 8L0 1.99965L2.00106 0L6.00035 4.00071L9.99965 0L12.0007 1.99965L6.00035 8Z"
          fill="#070331"
          fillOpacity="0.4"
        />
      </svg>
    </div>
  );
}

export default SelectInputDropdownArrow;
